import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=b4ba506e&"
import script from "./UserLogin.vue?vue&type=script&lang=js&"
export * from "./UserLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports